import * as React from 'react';

import * as styles from './OfferDesktop.css';
import { UIHeading2, Body1 } from '@cian/ui-kit';
import { clsx } from 'clsx';
import { useInView } from '@cian/valuation-utils-component';
import { TOffer } from 'shared/types/offer';
import { Underground } from '../Underground';
import { AboutBuilding } from '../AboutBuilding';
import { Labels } from '../Labels';

interface IOfferDesktopProps extends TOffer {
  onClick(id: number, position: number): void;
  position: number;
}

export const OfferDesktop: React.FC<IOfferDesktopProps> = ({
  onClick,
  href,
  imageUrl,
  price,
  features,
  position,
  labels,
  id,
  geo: { undergrounds, address, regionId, title },
}) => {
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  React.useEffect(() => {
    if (!id && inView) {
      // onShowTrap(analyticsData);
    }
  }, [inView, id]);

  const offerInfo = React.useMemo(() => {
    const buildingNode = title ? (
      <AboutBuilding key="building" name={title.name} link={title.link} onLinkClick={() => {}} />
    ) : null;
    const undergroundNode = undergrounds[0] ? (
      <Underground key="underground" underground={undergrounds[0]} regionId={regionId} />
    ) : null;
    const addressNode = address ? (
      <span
        key="address"
        className={clsx(styles['address'], ((!undergrounds[0] && !title) || !labels.length) && styles['two-rows'])}
      >
        {address}
      </span>
    ) : null;

    if (buildingNode && undergroundNode) {
      return [buildingNode, undergroundNode];
    }

    if (buildingNode && addressNode) {
      return [buildingNode, addressNode];
    }

    if (undergroundNode && addressNode) {
      return [undergroundNode, addressNode];
    }

    return addressNode;
  }, [address, labels.length, regionId, title, undergrounds]);

  return (
    <a
      ref={ref}
      onClick={() => onClick(id, position)}
      className={styles['container']}
      href={href}
      target="_blank"
      rel="noreferrer"
      data-name="OfferDesktop"
    >
      {imageUrl && (
        <div className={styles['image-container']}>
          <img src={imageUrl} className={styles['image']} />
        </div>
      )}
      <div className={styles['info']}>
        <Labels labels={labels} />
        <div className={styles['texts']}>
          <UIHeading2>{price}</UIHeading2>
          <Body1 whiteSpace="nowrap">{features}</Body1>
          {offerInfo}
        </div>
      </div>
    </a>
  );
};
